import { useTranslations } from 'next-intl';

import { OrderSideEnum } from '@flipster/apis/types';
import { useSnapshotSpec } from '@flipster/features/src/shared/snapshot/use-snapshot-spec';
import ArrowTrendingDownIcon from '@flipster/react/icon/generated/ArrowTrendingDownIcon';
import ArrowTrendingUpIcon from '@flipster/react/icon/generated/ArrowTrendingUpIcon';
import { flex } from '@flipster/styled-system/patterns';

interface Props {
  symbol: string;
  orderSide: string;
}

const OrderSide = ({ symbol, orderSide }: Props) => {
  const t = useTranslations();
  const { instrumentsKeyBySymbol } = useSnapshotSpec();

  const symbolInfo = instrumentsKeyBySymbol?.[symbol];

  if (!symbolInfo || orderSide === OrderSideEnum.Invalid) return null;

  const isLong = [OrderSideEnum.Buy, 'Long'].includes(orderSide);

  return (
    <span
      className={flex({
        align: 'center',
        gap: '2px',
        color: isLong ? 'content.accent.buy' : 'content.accent.sell',
        textStyle: 'Text/XS/Regular',
        pl: '4px',
        pr: '6px',
        py: '2px',
      })}
    >
      {isLong ? t('Autogen_common.r251126.s_Long') : t('Autogen_common.r251126.s_Short')}
      {isLong ? <ArrowTrendingUpIcon size={10} /> : <ArrowTrendingDownIcon size={10} />}
    </span>
  );
};

export default OrderSide;
